import Environment from '@/common/enums/environment.enum';
import { environment } from '@/globals';

export interface IDisplayAndVideoSSP {
  id: number;
  name: string;
}

export default class DisplayAndVideoSSPs {
  static getAvailableSSPs(): IDisplayAndVideoSSP[] {
    switch (environment) {
      case Environment.DEV:
      case Environment.STAGING:
        return [{ id: 25, name: 'Sharethrough' }];
      case Environment.UAT:
        return [{ id: 19, name: 'Sharethrough' }];
      case Environment.PROD:
        return [{ id: 25, name: 'Sharethrough' }];
      default:
        return [];
    }
  }
}
